// src/Login.js
import React, { useState } from "react";
import "./login.css";
import { useEffect } from "react";
import axios from "axios";
import { base_url } from "../counsellor/userReviews";
import { useAuth } from "../../utils/authContext";
import { useNavigate } from "react-router-dom";
import { AuthPassProvider, usePassAuth } from "../../utils/passwordContext";

const ChangePassword = () => {
  const [pass, setPass] = useState({
    password: "",
    confirmPassword: "",
  });
  const {setIsAuthenticated}=usePassAuth()
  const [errors, setErrors] = useState("");
  const navigate = useNavigate();

  const handleValidation = () => {
    const newErrors = {};
    const { password, confirmPassword } = pass;
    if (
      !password ||
      password == "" ||
      !confirmPassword ||
      confirmPassword == ""
    )
      newErrors.password = "Password & confirm password both are required";
    else if (password.length < 6 || password.length > 16)
      newErrors.password = "Password must be 8-16 character long";
    else if (password !== confirmPassword)
      newErrors.password = "Password & Confirm password must be same ";
        setErrors(newErrors)
    return Object.keys(newErrors).length == 0;
  };

  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      const timeoutId = setTimeout(() => {
        setErrors({});
      }, 5000);

      // Clean up the timeout on component unmount
      return () => clearTimeout(timeoutId);
    }
  }, [errors]);
  
  const change_password = () => {
    
    const flag = handleValidation();
    if (flag) {
      axios
        .post(base_url + "/password", { password: pass.password })
        .then((res) => {
          console.log("Response--------------")
          alert(res.data.message)
          setIsAuthenticated(false)
        })
        .catch((err) => {
          console.log('Error in change password---------',err)
          alert(err.reponse.data.message)
        });
    }
  };

  return (
    <div className="login-container">
      <div className="login-form">
        <h2>Reset Password</h2>
        <div className="input-container-login">
          <input
            type="text"
            placeholder="password"
            value={pass.password}
            onChange={(e) => setPass({ ...pass, password: e.target.value })}
          />
        </div>
        <div className="input-container-login">
          <input
            type="password"
            placeholder="Confirm Password"
            value={pass.confirmPassword}
            onChange={(e) =>
              setPass({ ...pass, confirmPassword: e.target.value })
            }
          />
          {errors?.password && (
            <span className="login-errors">{errors?.password}</span>
          )}
        </div>

        <button onClick={change_password}>Reset Password</button>
      </div>
    </div>
  );
};

export default ChangePassword;
